import React, { useEffect, useState } from "react";
import axios from "axios";

const RefundBankModal = ({ banks, onProceed, onClose }) => {
  const [resolvingAccount, setResolvingAccount] = useState(false);

  const [refundBank, setRefundBank] = useState({
    bank: "",
    bankName: "",
    number: "",
    name: "",
  });

  useEffect(() => {
    if (!refundBank.bank || refundBank.number.length !== 10) return;

    const resolveAccount = async () => {
      setResolvingAccount(true);
      try {
        const res = await axios.get(
          `/paystack/bank/resolve-account/${refundBank.number}/${refundBank.bank}`,
        );
        setRefundBank((prev) => ({
          ...prev,
          name: res.data?.data?.account_name || "",
        }));
      } catch (error) {
        console.error("Failed to resolve account", error);
        setRefundBank((prev) => ({ ...prev, name: "" }));
      } finally {
        setResolvingAccount(false);
      }
    };

    resolveAccount();
  }, [refundBank.bank, refundBank.number]);

   const bankDetails = {
    bankName: refundBank.bankName,
    accountName: refundBank.name,
    accountNumber: refundBank.number,
  };

  const isFormValid =
    refundBank.bank && refundBank.number.length === 10 && refundBank.name;

  const isProduction = process.env.NODE_ENV === "production";

  return (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content">
        <h2>Add Bank Details</h2>
        <p className="purchase-modal-subtitle">
          Provide the bank account to receive your refund
        </p>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onProceed(bankDetails);
          }}
        >
          <div className="form-group">
            <label>Bank Name</label>
            <select
              className="input"
              value={refundBank.bank}
              onChange={(e) => {
                const selectedBank = banks.find(
                  (b) => b.code === e.target.value,
                );
                setRefundBank({
                  ...refundBank,
                  bank: e.target.value,
                  bankName: selectedBank?.name || "",
                  name: "",
                });
              }}
            >
              <option value="">Select Bank</option>
              {banks.map((bank) => (
                <option key={bank.id} value={bank.code}>
                  {bank.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Account Number</label>
            <input
              className="input"
              type="text"
              placeholder="Enter 10-digit account number"
              maxLength={10}
              value={refundBank.number}
              onChange={(e) =>
                setRefundBank({
                  ...refundBank,
                  number: e.target.value.replace(/\D/g, ""),
                  name: "",
                })
              }
            />
          </div>

          <div className="form-group">
            <label>Account Details</label>
            <div className="account-details-box">
              {resolvingAccount ? (
                <span className="muted">Verifying account...</span>
              ) : refundBank.name ? (
                <>
                  <strong>{refundBank.name}</strong>
                  <span>
                    {refundBank.bankName} • {refundBank.number}
                  </span>
                </>
              ) : (
                <span className="muted">Account details will appear here</span>
              )}
            </div>
          </div>

          <div className="modal-controls">
            <button
              type="button"
              className="modal-button other-purchase-cancel"
              onClick={onClose}
            >
              Close
            </button>

            <button
              type="submit"
              className="modal-button proceed-button"
              disabled={isProduction && (!isFormValid || resolvingAccount)}
            >
              {resolvingAccount ? "Verifying..." : "Proceed"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
export default RefundBankModal;
